import styled from 'styled-components';
import { vars } from '@agendor/ui';

// The layout shared by the wide modals that manage a list of items: the list on
// the left, the selected item's form beside it, one column at a time on mobile.
export const MasterDetail = styled.div<{ $hasSelection: boolean }>`
    display: grid;
    /* Proportional so the list never rivals the detail in a narrow window,
       with a floor for the width one line of a title needs. */
    grid-template-columns: minmax(180px, 32%) 1fr;
    gap: 16px;
    min-height: 320px;
    align-items: start;

    /* One column at a time on mobile. Stated here so no call site has to spell
       the same condition twice, once inverted. */
    @media (max-width: 600px) {
        grid-template-columns: 1fr;
        min-height: 0;

        >*: ${(props) => (props.$hasSelection ? 'first-child' : 'last-child')} {
            display: none;
        }
    }
`;

export const MasterList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const DetailPanel = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
`;

export const MasterItem = styled.button.attrs({ type: 'button' })<{ $active: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
    padding: 12px 16px;
    border-radius: 6px;
    border: 1px solid ${(props) => (props.$active ? vars.dividerColor : 'transparent')};
    background: ${(props) => (props.$active ? vars.primaryColorLight : 'transparent')};
    color: ${vars.foregroundColor};
    font-weight: 400;
    font-size: 1rem;
    text-align: left;
    cursor: pointer;
    font-family: inherit;

    &:hover {
        background: ${(props) => (props.$active ? vars.primaryColorLight : vars.backgroundColorBright)};
        border-color: ${vars.dividerColor};
    }
`;

export const MasterItemMeta = styled.span`
    font-size: 0.8rem;
    line-height: 1.35;
    color: #888;
    font-weight: 400;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 48px 24px;
    text-align: center;
`;

export const DetailPlaceholder = styled(EmptyState).attrs({ as: 'p' })`
    margin: 0;
    color: #666;
    font-size: 0.9rem;
`;
